import moment from 'moment';
import { createI18n, Locale } from 'vue-i18n';
// @ts-ignore
import messages from '../shared/assets/lang/en.json';

export const DEFAULT_LOCALE: Locale = 'en';

moment.locale(DEFAULT_LOCALE);

export default createI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  legacy: false,
  globalInjection: true,
  messages: {
    [DEFAULT_LOCALE]: messages,
  },
});